/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plannamevereinm3Inputs */

const en_plannamevereinm3 = /** @type {(inputs: Plannamevereinm3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Club M`)
};

const de_plannamevereinm3 = /** @type {(inputs: Plannamevereinm3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verein M`)
};

/**
* | output |
* | --- |
* | "Club M" |
*
* @param {Plannamevereinm3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const plannamevereinm3 = /** @type {((inputs?: Plannamevereinm3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plannamevereinm3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plannamevereinm3(inputs)
	return de_plannamevereinm3(inputs)
});
export { plannamevereinm3 as "planNameVereinM" }